import { Button, styled } from '@mui/material';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ theme, variant }) => {
  // Default styles
  let styles = {
    minWidth: 140,
    fontSize: 12,
    textTransform: 'none',
    borderRadius: '27px',
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  };

  // Variant-specific styles
  switch (variant) {
    case 'error':
      // red button
      styles = {
        ...styles,
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.error.main,
        border: `1px solid ${theme.palette.error.main}`,
        '&:hover': {
          backgroundColor: theme.palette.error.main,
          opacity: 0.9,
        },
      };
      break;
    case 'gradient':
      // gradient button
      styles = {
        ...styles,
        color: theme.palette.text.secondary,
        background: theme.palette.gradient.main,
        border: '1px solid rgba(255,255,255,.3)',
        '&:hover': {
          border: '1px solid rgba(255,255,255,.5)',
          opacity: 0.9,
        },
      };
      break;
    case 'secondaryLight':
      // transparent button for dark backgrounds
      styles = {
        ...styles,
        color: theme.palette.text.secondary,
        backgroundColor: 'transparent',
        border: '1px solid rgba(255,255,255,.3)',
        '&:hover': {
          border: '1px solid rgba(255,255,255,.5)',
        },
      };
      break;
    case 'secondaryDark':
      // transparent button for light backgrounds
      styles = {
        ...styles,
        color: theme.palette.text.primary,
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.text.primary}`,
        '&:hover': {
          opacity: 0.6,
        },
      };
      break;

    default:
      break;
  }

  return styles;
});

const CustomButton = ({ children, variant, ...otherProps }) => {
  return (
    <StyledButton variant={variant} disableElevation {...otherProps}>
      {children}
    </StyledButton>
  );
};

export default CustomButton;
